import PageHeader from '../../components/layout/PageHeader';
import ExcelTemplates from './ExcelTemplates';

export default function ExcelTemplatesPage() {
  return (
    <div>
      <PageHeader title="Excel Templates" description="Column layouts used to download candidate data as Excel." />
      <ExcelTemplates />
    </div>
  );
}
